/* eslint-disable no-constant-condition */

/* eslint-disable no-plusplus */

/* eslint-disable no-await-in-loop */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable react/no-array-index-key */
import axios from 'axios';
import dayjs from 'dayjs';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  getAudienceByCategory,
  getCampaignMessageByCampaignID,
} from '@src/api/twilio-campaigns';
import LabTabs from '@src/components/commons/tabs.common';
import { useAuth } from '@src/contexts/authContext';
import { formatDate } from '@src/utils';

const url = `${process.env.REACT_APP_API_URL}`;

function getPreviewMessage(campaign) {
  let message = campaign?.content_template_definitions?.body || '';

  const variables = campaign?.content_template_variable?.variables || [];

  variables.forEach((v) => {
    message = message.replaceAll(`{{${v.idx}}}`, v.value || '');
  });

  const parts = message.split(/(\*.*?\*)/g);

  return parts.map((part, i) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      return <b key={i}>{part.slice(1, -1)}</b>;
    }
    return <span key={i}>{part}</span>;
  });
}

export default function ViewCampaign() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { campaignId } = useParams();

  const [campaign, setCampaign] = useState({});

  const [audience, setAudience] = useState([]);

  const fetchData = () => {
    if (auth.idToken && campaignId) {
      axios
        .get(`${url}/admin/v3/messages/twilio/campaigns/${campaignId}`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((response) => {
          setCampaign(response.data?.response?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const fetchAudience = async () => {
    try {
      const res = await getAudienceByCategory({
        token: auth.idToken,
      });
      setAudience(res.data?.response?.data);
    } catch (err) {
      console.error('Error fetching:', err);
    }
  };

  useEffect(() => {
    fetchData();
    fetchAudience();
  }, [auth.idToken, campaignId]);

  const [openModal, setOpenModal] = useState(false);
  const showModal = () => {
    setOpenModal(true);
  };

  const handleBack = async () => {
    navigate('/campaign-management');
  };

  const handleUpdateStatus = (type) => {
    let newStatus = campaign?.cmp_status;

    if (type === 'schedule') {
      if (campaign?.cmp_status === 'published') {
        newStatus = 'scheduled';
      } else {
        newStatus = 'scheduled';
      }
    } else if (type === 'cancel') {
      if (campaign?.cmp_status === 'scheduled') {
        newStatus = 'cancelled';
      } else {
        newStatus = 'cancelled';
      }
    } else if (campaign?.cmp_status === 'tested') {
      newStatus = 'published';
    } else if (campaign?.cmp_status === 'testing') {
      newStatus = 'published';
    } else if (campaign?.cmp_status === 'draft') {
      newStatus = 'tested';
    }

    const formData = {
      status: newStatus,
    };

    axios
      .patch(
        `${url}/admin/v3/messages/twilio/campaigns/${campaignId}/status`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      )
      .then((response) => {
        console.log('Status updated successfully:', response);
        setCampaign({ ...campaign, cmp_status: newStatus });
        toast.success(`Status updated successfully: ${newStatus}`, {
          position: 'top-center',
          autoClose: 2000,
        });
        fetchData();
      })
      .catch((error) => {
        console.error(error.message);
        toast.error(`${error.response?.data?.message || 'An error occurred'}`, {
          position: 'top-center',
          autoClose: 2000,
        });
      });
  };

  const [hasRunTesting, setHasRunTesting] = useState(false);

  useEffect(() => {
    if (!openModal) setHasRunTesting(false);
  }, [openModal]);

  const handleRunTesting = () => {
    axios
      .post(
        `${url}/admin/v3/messages/twilio/campaigns/${campaignId}/test`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      )
      .then((response) => {
        setHasRunTesting(true);
        console.log('Run testing...', response);
        setCampaign({ ...campaign });
        toast.success(`Run testing...`, {
          position: 'top-center',
          autoClose: 2000,
        });
      })
      .catch((error) => {
        console.error(error.message);
        toast.error(
          `${error.response?.data?.system?.message || 'An error occurred'}`,
          {
            position: 'top-center',
            autoClose: 2000,
          },
        );
      });
  };

  const handleExecute = () => {
    axios
      .post(
        `${url}/admin/v3/messages/twilio/campaigns/${campaignId}/execute`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      )
      .then((response) => {
        console.log('Status updated successfully:', response);
        setCampaign({ ...campaign });
        toast.success(`Status updated successfully: executed`, {
          position: 'top-center',
          autoClose: 2000,
        });
        fetchData();
      })
      .catch((error) => {
        console.error(error.message);
        toast.error(
          `${error.response?.data?.system?.message || 'An error occurred'}`,
          {
            position: 'top-center',
            autoClose: 2000,
          },
        );
      });
  };

  const handleAddAudience = () => {
    const formData = {
      cmp_audience_test: campaign?.cmp_audience_test,
    };

    axios
      .put(
        `${url}/admin/v3/messages/twilio/campaigns/${campaignId}`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      )
      .then((response) => {
        console.log('Status updated successfully:', response);
        setCampaign({ ...campaign });
      })
      .catch((error) => {
        console.error(error.message);
      });
  };

  const bodyText = (campaign?.content_template_definitions?.body || '').trim();
  const bodyWords = bodyText.split(/\s+/).filter(Boolean);

  const valuesText = (campaign?.content_template_variable?.variables || [])
    .map((v) => v.value || '')
    .join(' ')
    .trim();
  const valueWords = valuesText.split(/\s+/).filter(Boolean);

  const totalWords = bodyWords.length + valueWords.length;

  return (
    <div>
      <Box fullwidth margin={2}>
        <Button
          sx={{
            textTransform: 'none',
            paddingLeft: 0,
          }}
          className='px-6 font-bold text-purple-500'
          variant='text'
          // eslint-disable-next-line react/jsx-no-bind
          onClick={handleBack}
        >
          Back
        </Button>

        <GeneralInfo campaign={campaign} />
        <Tabs
          campaign={campaign}
          setCampaign={setCampaign}
          totalWords={totalWords}
          showModal={showModal}
          handleUpdateStatus={handleUpdateStatus}
          handleExecute={handleExecute}
        />
      </Box>

      <Dialog
        maxWidth='lg'
        fullwidth
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <DialogTitle>Choose one testing account</DialogTitle>

        <DialogContent>
          <div className='flex justify-between'>
            <Select
              fullWidth
              displayEmpty
              value={campaign?.cmp_audience_test ?? null}
              onChange={(e) =>
                setCampaign({
                  ...campaign,
                  cmp_audience_test: e.target.value ?? null,
                })
              }
              sx={{ mt: 1, mb: '16px', borderRadius: '8px', width: '500px' }}
              MenuProps={{
                disablePortal: true,
                PaperProps: {
                  style: {
                    zIndex: 1302,
                  },
                },
              }}
              renderValue={(selected) => {
                if (!selected)
                  return <span style={{ color: '#8C8C8C' }}>Select one</span>;
                const selectedItem = audience?.find(
                  (item) => item?.the_id === selected,
                );
                return selectedItem ? selectedItem.audi_segment_name : selected;
              }}
            >
              <MenuItem value={null}>
                <span style={{ color: '#8C8C8C' }}>Select one</span>
              </MenuItem>
              {audience?.map((item) => (
                <MenuItem key={item?.the_id} value={item?.the_id}>
                  {item?.audi_segment_name}
                </MenuItem>
              ))}
            </Select>
          </div>
        </DialogContent>

        <DialogActions>
          <Box
            display='flex'
            justifyContent='space-between'
            width='100%'
            mb={2}
          >
            <Button
              sx={{ textTransform: 'none', ml: 1.5 }}
              onClick={() => {
                handleRunTesting();
                handleAddAudience();
              }}
              disabled={
                !campaign?.cmp_audience_test ||
                (campaign?.cmp_status === 'tested' &&
                  campaign?.cmp_audience_test === null)
              }
              color='secondary'
            >
              Run testing
            </Button>
            <Box>
              <Button
                sx={{ textTransform: 'none' }}
                onClick={() => setOpenModal(false)}
                color='error'
              >
                Cancel
              </Button>
              <Button
                sx={{ textTransform: 'none', mr: 1 }}
                onClick={() => {
                  setOpenModal(false);
                  handleUpdateStatus();
                  fetchData();
                }}
                disabled={!hasRunTesting}
                color='primary'
              >
                Mark as tested
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <br />
    </div>
  );
}

function GeneralInfo({ campaign }) {
  return (
    <Card
      sx={{
        backgroundColor: 'white',
        p: 3,
        borderRadius: 4,
        ml: 3,
        width: '96%',
        mt: 4,
      }}
    >
      <Accordion
        // defaultExpanded
        sx={{
          boxShadow: 'none',
          border: 'none',
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 0 }}>
          <Typography
            pl={2}
            fontWeight={600}
            fontSize={20}
            fontFamily='Poppins'
          >
            General Information
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={4} pt={2}>
            <Grid item xs={12} md={4}>
              <Box>
                <Typography fontFamily='Poppins'>Campaign name</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.cmp_name || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>
                  Campaign description
                </Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.cmp_description || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Campaign code</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.cmp_code || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Is active</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.is_active ? 'true' : 'false'}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box>
                <Typography fontFamily='Poppins'>Audience</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.audienceSegment?.audi_segment_name || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Account</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.account?.acc_name || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Inbox</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.inbox?.inbox_name || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Sender</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.sender?.sender_name || '-'}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box>
                <Typography fontFamily='Poppins'>
                  Trigger during business hours
                </Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.cmp_trigger_only_during_business_hours
                    ? 'true'
                    : 'false'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Campaign type</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {campaign?.cmp_type || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Scheduled at</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {formatDate(campaign?.cmp_scheduled_at) || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Created at</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {formatDate(campaign?.ww_created_at) || '-'}
                </Typography>
              </Box>
              <Box mt={3}>
                <Typography fontFamily='Poppins'>Last updated at</Typography>
                <Typography color='gray' mt={1} fontFamily='Poppins'>
                  {formatDate(campaign?.ww_updated_at) || '-'}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Card>
  );
}

function PreviewMessage({
  campaign,
  setCampaign,
  totalWords,
  showModal,
  handleUpdateStatus,
  handleExecute,
}) {
  const [executeModal, setExecuteModal] = useState(false);
  const showExecuteModal = () => {
    setExecuteModal(true);
  };
  const [scheduleModal, setScheduleModal] = useState(false);
  const showScheduleModal = () => {
    setScheduleModal(true);
  };
  const [cancelModal, setCancelModal] = useState(false);
  const showCancelModal = () => {
    setCancelModal(true);
  };
  return (
    <Card
      sx={{
        backgroundColor: 'white',
        p: 3,
        borderRadius: 4,
        ml: 1,
        width: '100%',
        mt: 2,
      }}
    >
      {/* BODY */}
      <div className='mt-4 grid grid-cols-2 gap-6 pl-2'>
        {/* LEFT: Content info */}
        <Box pl={1}>
          <Box>
            <Typography fontFamily='Poppins'>Content template name</Typography>
            <Typography color='gray' mt={1} fontFamily='Poppins'>
              {campaign?.contentTemplate?.ct_name || '-'}
            </Typography>
          </Box>

          <Box mt={3}>
            <Typography fontFamily='Poppins'>
              Content template definitions
            </Typography>
            <Typography
              color='gray'
              mt={1}
              fontFamily='Poppins'
              fontWeight={600}
            >
              Body:
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={8}
              disabled
              size='medium'
              variant='outlined'
              sx={{
                '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                mt: 1,
              }}
              value={campaign?.content_template_definitions?.body}
              onChange={(e) =>
                setCampaign({
                  ...campaign,
                  body: e.target.value,
                })
              }
            />
          </Box>

          <Box mt={3}>
            <Typography fontFamily='Poppins'>
              Content template variables
            </Typography>
            <Typography
              color='gray'
              mt={1}
              fontFamily='Poppins'
              fontWeight={600}
            >
              Count:{' '}
              {campaign?.content_template_variable?.meta?.variable_count || '-'}
              &nbsp; variable(s)
            </Typography>

            <br />
            {campaign?.content_template_variable?.variables?.map((v) => (
              <Box key={v.idx} sx={{ mt: 2 }}>
                <Typography display='flex'>
                  <Typography fontWeight={600}>{`${v.var_code}`}</Typography>
                  &nbsp; &nbsp;
                  {`${v.label}`}
                </Typography>
                <Typography
                  color='gray'
                  display='flex'
                  pt={1}
                  sx={{ whiteSpace: 'pre-line' }}
                >
                  <Typography fontWeight={600}>Value:</Typography>
                  &nbsp; {v.value || '-'}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* RIGHT: Mobile Preview */}
        <Box
          sx={{
            alignItems: 'center',
            justifyContent: 'flex-end',
            margin: '0 auto',
          }}
        >
          <div className='flex'>
            <Typography fontWeight={600} fontFamily='Poppins'>
              Status:&nbsp;
            </Typography>
            <Typography fontFamily='Poppins' mr={3}>
              {campaign?.cmp_status || '-'}
            </Typography>
          </div>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              mt: 3,
            }}
          >
            {/* Buttons */}
            <div className='flex space-x-3'>
              {/* Test Button */}
              <Button
                sx={{
                  textTransform: 'none',
                  backgroundColor:
                    campaign?.cmp_status === 'draft' ||
                    campaign?.cmp_status === 'testing'
                      ? '#F3E8FF'
                      : '#E9D5FF',
                  color: '#6B21A8',
                  borderRadius: '8px',
                  px: 2,
                  fontWeight: 600,
                  height: '42px',
                  '&:hover': { backgroundColor: '#E9D5FF' },
                }}
                onClick={showModal}
                disabled={
                  campaign?.cmp_status !== 'draft' &&
                  campaign?.cmp_status !== 'testing'
                }
                className={
                  campaign?.cmp_status !== 'draft' &&
                  campaign?.cmp_status !== 'testing'
                    ? 'cursor-not-allowed bg-gray-400 text-white'
                    : ''
                }
              >
                Test
              </Button>

              {/* Publish Button */}
              <Button
                sx={{
                  textTransform: 'none',
                  backgroundColor:
                    campaign?.cmp_status === 'draft' ||
                    campaign?.cmp_status === 'tested'
                      ? '#E0F2FE'
                      : '#BAE6FD',
                  color: '#0369A1',
                  borderRadius: '8px',
                  px: 2,
                  fontWeight: 600,
                  height: '42px',
                  '&:hover': { backgroundColor: '#BAE6FD' },
                }}
                onClick={handleUpdateStatus}
                disabled={campaign?.cmp_status !== 'tested'}
                className={
                  campaign?.cmp_status !== 'tested'
                    ? 'cursor-not-allowed bg-gray-400 text-white'
                    : ''
                }
              >
                Publish
              </Button>

              {/* Execute Button */}
              <Tooltip title='Execute campaign manually' arrow>
                <Button
                  sx={{
                    textTransform: 'none',
                    backgroundColor:
                      campaign?.cmp_status === 'published'
                        ? '#F3E8FF'
                        : '#E9D5FF',
                    color: '#6B21A8',
                    borderRadius: '8px',
                    px: 2,
                    fontWeight: 600,
                    height: '42px',
                    '&:hover': { backgroundColor: '#E9D5FF' },
                  }}
                  // onClick={() => handleExecute()}
                  onClick={showExecuteModal}
                  disabled={campaign?.cmp_status !== 'published'}
                  className={
                    campaign?.cmp_status !== 'published'
                      ? 'cursor-not-allowed bg-gray-400 text-white'
                      : ''
                  }
                >
                  Execute
                </Button>
              </Tooltip>

              {/* Scheduled Button */}
              <Tooltip title='Execute campaign with cron' arrow>
                <Button
                  sx={{
                    textTransform: 'none',
                    backgroundColor:
                      campaign?.cmp_status === 'executed'
                        ? '#E0F2FE'
                        : '#BAE6FD',
                    color: '#0369A1',
                    borderRadius: '8px',
                    px: 2,
                    fontWeight: 600,
                    height: '42px',
                    '&:hover': { backgroundColor: '#BAE6FD' },
                  }}
                  // onClick={() => handleUpdateStatus('schedule')}
                  onClick={showScheduleModal}
                  disabled={campaign?.cmp_status !== 'published'}
                  className={
                    campaign?.cmp_status !== 'published'
                      ? 'cursor-not-allowed bg-gray-400 text-white'
                      : ''
                  }
                >
                  Scheduled
                </Button>
              </Tooltip>

              <Tooltip title='Cancel schedule' arrow>
                <Button
                  sx={{
                    textTransform: 'none',
                    backgroundColor:
                      campaign?.cmp_status === 'scheduled'
                        ? '#FEE2E2'
                        : '#FCA5A5',
                    color: '#B91C1C',
                    borderRadius: '8px',
                    px: 2,
                    fontWeight: 600,
                    height: '42px',
                    '&:hover': { backgroundColor: '#FCA5A5' },
                  }}
                  // onClick={() => handleUpdateStatus('cancelled')}
                  onClick={showCancelModal}
                  disabled={campaign?.cmp_status !== 'scheduled'}
                  className={
                    campaign?.cmp_status !== 'scheduled'
                      ? 'cursor-not-allowed bg-gray-400 text-white'
                      : ''
                  }
                >
                  Cancel
                </Button>
              </Tooltip>
            </div>

            <Dialog
              maxWidth='lg'
              fullwidth
              open={executeModal}
              onClose={() => setExecuteModal(false)}
            >
              <DialogTitle>Confirmation</DialogTitle>

              <DialogContent sx={{ mt: 2 }}>
                <Typography>
                  Are you sure want to execute this campaign?
                </Typography>
                <Typography>This action can`t be undone</Typography>
              </DialogContent>

              <DialogActions>
                <Box display='flex' justifyContent='end' width='100%' mb={2}>
                  <Box>
                    <Button
                      sx={{ textTransform: 'none' }}
                      onClick={() => setExecuteModal(false)}
                      color='error'
                    >
                      Cancel
                    </Button>
                    &nbsp;
                    <Button
                      sx={{ textTransform: 'none', mr: 1 }}
                      onClick={() => {
                        handleExecute();
                        setExecuteModal(false);
                      }}
                      color='primary'
                    >
                      Continue
                    </Button>
                  </Box>
                </Box>
              </DialogActions>
            </Dialog>

            <Dialog
              maxWidth='lg'
              fullwidth
              open={scheduleModal}
              onClose={() => setScheduleModal(false)}
            >
              <DialogTitle>Confirmation</DialogTitle>

              <DialogContent sx={{ mt: 2 }}>
                <Typography>
                  Are you sure want to schedule this campaign?
                </Typography>
                <Typography>This action can`t be undone</Typography>
              </DialogContent>

              <DialogActions>
                <Box display='flex' justifyContent='end' width='100%' mb={2}>
                  <Box>
                    <Button
                      sx={{ textTransform: 'none' }}
                      onClick={() => setScheduleModal(false)}
                      color='error'
                    >
                      Cancel
                    </Button>
                    &nbsp;
                    <Button
                      sx={{ textTransform: 'none', mr: 1 }}
                      onClick={() => {
                        handleUpdateStatus('schedule');
                        setScheduleModal(false);
                      }}
                      color='primary'
                    >
                      Continue
                    </Button>
                  </Box>
                </Box>
              </DialogActions>
            </Dialog>

            <Dialog
              maxWidth='lg'
              fullwidth
              open={cancelModal}
              onClose={() => setCancelModal(false)}
            >
              <DialogTitle>Confirmation</DialogTitle>

              <DialogContent sx={{ mt: 2 }}>
                <Typography>
                  Are you sure want to cancel the schedule?
                </Typography>
                <Typography>This action can`t be undone</Typography>
              </DialogContent>

              <DialogActions>
                <Box display='flex' justifyContent='end' width='100%' mb={2}>
                  <Box>
                    <Button
                      sx={{ textTransform: 'none' }}
                      onClick={() => setCancelModal(false)}
                      color='error'
                    >
                      Cancel
                    </Button>
                    &nbsp;
                    <Button
                      sx={{ textTransform: 'none', mr: 1 }}
                      onClick={() => {
                        handleUpdateStatus('cancel');
                        setCancelModal(false);
                      }}
                      color='primary'
                    >
                      Continue
                    </Button>
                  </Box>
                </Box>
              </DialogActions>
            </Dialog>
          </Box>
          <Box
            sx={{
              border: '10px solid black',
              borderRadius: '30px',
              width: '25vw',
              height: '80vh',
              margin: '0 auto',
              backgroundColor: '#ffffff',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              maxWidth: 390,
              maxHeight: 800,
              mt: 6,
            }}
          >
            {/* HEADER HP */}
            <Box
              sx={{
                p: 2,
                borderBottom: '1px solid #ccc',
                background: '#fff',
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Typography fontSize={14} fontWeight={600}>
                {campaign?.cmp_name || 'Template Name'}
              </Typography>
              <Typography fontSize={14} fontWeight={600}>
                {totalWords || '0'}/1024
              </Typography>
            </Box>

            {/* BODY PREVIEW */}
            <Box sx={{ flex: 1, p: 2, overflowY: 'auto' }}>
              <Typography fontSize={14} whiteSpace='pre-line'>
                {getPreviewMessage(campaign)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </div>
      <br />
    </Card>
  );
}

function ReportCard() {
  const [report, setReport] = useState([]);
  const { campaignId } = useParams();

  const { auth } = useAuth();
  const [loading, setLoading] = useState();

  const [filteredReport, setFilteredReport] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 0,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
  });
  const fetchData = async (page = 1, limit = 10) => {
    if (!auth?.idToken || !campaignId) return;

    try {
      setLoading(true);

      let allData = [];
      let currentPage = page;
      let paginationData = {};

      while (true) {
        const res = await getCampaignMessageByCampaignID({
          token: auth.idToken,
          id: campaignId,
          params: {
            page: currentPage,
            limit,
          },
        });

        const response = res?.data?.response;
        const currentData = Array.isArray(response?.data) ? response.data : [];
        const currentPagination = response?.pagination || {};

        allData = [...allData, ...currentData];
        paginationData = currentPagination;

        if (
          !currentPagination?.totalPages ||
          currentPage >= currentPagination.totalPages
        )
          break;

        currentPage++;
      }

      setReport(allData);
      setPagination(paginationData);
    } catch (err) {
      console.error('Error fetching all campaign messages:', err);
      setReport([]);
      setPagination({});
    } finally {
      setLoading(false);
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0);
    fetchData(1, newLimit);
  };

  const [startDate, setStartDate] = useState(null);
  const [searchName, setSearchName] = useState('');
  const [searchScope, setSearchScope] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const [searchAudience, setSearchAudience] = useState('');

  useEffect(() => {
    let data = [...(report || [])];

    // filter by name
    if (searchName) {
      data = data.filter((c) =>
        c.audience_contact_name
          ?.toLowerCase()
          .includes(searchName.toLowerCase()),
      );
    }

    if (searchAudience) {
      data = data.filter((c) =>
        c.audience_contact_segment
          ?.toLowerCase()
          .includes(searchAudience.toLowerCase()),
      );
    }

    if (searchStatus) {
      data = data.filter((c) => c.msg_sent_provider_status === searchStatus);
    }

    // filter by scope

    if (searchScope) {
      data = data.filter((c) => c.data_scope === searchScope);
    }

    // filter by date
    if (startDate) {
      const formattedDate = dayjs(startDate).format('YYYY-MM-DD');
      data = data.filter(
        (c) => dayjs(c.msg_sent_at).format('YYYY-MM-DD') === formattedDate,
      );
    }

    setFilteredReport(data);
  }, [
    report,
    searchName,
    searchScope,
    startDate,
    searchAudience,
    searchStatus,
  ]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    auth.idToken,
    searchName,
    searchScope,
    searchAudience,
    startDate,
    searchStatus,
  ]);

  const handleStartDate = (newValue) => {
    setStartDate(newValue ? dayjs(newValue) : null);
  };

  return (
    <Box
      sx={{
        borderRadius: 4,
        ml: 1,
        width: '100%',
        mt: 2,
      }}
    >
      <div className='flex justify-start'>
        <Box
          sx={{ width: '100%', height: 'auto' }}
          className='rounded-xl bg-white px-6 py-4'
        >
          <Grid container spacing={1.1}>
            {/* Name */}
            <Grid item xs={12} sm={6} md={2.1}>
              <Typography className='font-poppins text-sm text-gray-400'>
                Name
              </Typography>
              <TextField
                fullWidth
                variant='outlined'
                size='small'
                sx={{
                  mt: 1,
                  '& .MuiOutlinedInput-root': { borderRadius: 2 },
                }}
                value={searchName || ''}
                onChange={(e) => setSearchName(e.target.value)}
                placeholder='Search by name'
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2.1}>
              <Typography className='font-poppins text-sm text-gray-400'>
                Audience
              </Typography>
              <TextField
                fullWidth
                variant='outlined'
                size='small'
                sx={{
                  mt: 1,
                  '& .MuiOutlinedInput-root': { borderRadius: 2 },
                }}
                value={searchAudience || ''}
                onChange={(e) => setSearchAudience(e.target.value)}
                placeholder='Search by audience'
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Typography className='font-poppins text-sm text-gray-400'>
                Status
              </Typography>
              <Select
                fullWidth
                size='small'
                displayEmpty
                sx={{ mt: 1, borderRadius: 2 }}
                MenuProps={{
                  disablePortal: true,
                  PaperProps: { style: { zIndex: 1302 } },
                }}
                value={searchStatus || ''}
                onChange={(e) => setSearchStatus(e.target.value)}
              >
                <MenuItem disabled value=''>
                  <em style={{ color: '#8C8C8C' }}>Select</em>
                </MenuItem>
                <MenuItem value=''>ALL</MenuItem>
                <MenuItem value='accepted'>Accepted</MenuItem>
                <MenuItem value='delivered'>Delivered</MenuItem>
                <MenuItem value='failed'>Failed</MenuItem>
                <MenuItem value='queued'>Queued</MenuItem>
                <MenuItem value='read'>Read</MenuItem>
                <MenuItem value='sent'>Sent</MenuItem>
                <MenuItem value='undelivered'>Undelivered</MenuItem>
              </Select>
            </Grid>

            {/* Status */}
            <Grid item xs={12} sm={6} md={2}>
              <Typography className='font-poppins text-sm text-gray-400'>
                Data scope
              </Typography>
              <Select
                fullWidth
                size='small'
                displayEmpty
                sx={{ mt: 1, borderRadius: 2 }}
                MenuProps={{
                  disablePortal: true,
                  PaperProps: { style: { zIndex: 1302 } },
                }}
                value={searchScope || ''}
                onChange={(e) => setSearchScope(e.target.value)}
              >
                <MenuItem disabled value=''>
                  <em style={{ color: '#8C8C8C' }}>Select</em>
                </MenuItem>
                <MenuItem value=''>ALL</MenuItem>
                <MenuItem value='TEST'>TEST</MenuItem>
                <MenuItem value='LIVE'>LIVE</MenuItem>
              </Select>
            </Grid>

            {/* Date + Clear */}
            <Grid item xs={12} sm={6} md={3.2}>
              <Typography className='font-poppins text-sm text-gray-400'>
                Sent Date
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    reduceAnimations
                    value={startDate}
                    onChange={handleStartDate}
                    format='DD-MM-YYYY'
                    sx={{
                      flex: 1,
                      '& .MuiOutlinedInput-root': { borderRadius: 2 },
                    }}
                    slotProps={{ textField: { size: 'small' } }}
                  />
                </LocalizationProvider>

                <Button
                  variant='contained'
                  className='rounded-md bg-cyan-600 py-2 text-sm font-bold'
                  sx={{
                    width: '80px',
                    height: '38px',
                    textTransform: 'none',
                    backgroundColor: 'white',
                    '&:hover': {
                      backgroundColor: 'white',
                    },
                  }}
                  onClick={() => {
                    setSearchName('');
                    setSearchStatus('');
                    setSearchAudience('');
                    setSearchScope('');
                    setStartDate(null);
                    fetchData();
                  }}
                >
                  Clear
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
      <br />
      <TableContainer
        className='rounded-xl'
        component={Paper}
        style={{
          width: '100%',
          paddingBottom: '12px',
          paddingRight: '12px',
          backgroundColor: '#ffffff',
          borderColor: 'ffffff',
        }}
      >
        <Table
          sx={{
            minWidth: 350,
            backgroundColor: '#ffffff',
            borderColor: 'ffffff',
          }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ width: 80 }}
                className='text-center text-xs font-bold text-gray-500'
              >
                Data Scope
              </TableCell>

              <TableCell
                sx={{ width: 250, p: 1 }}
                className='text-center text-xs font-bold text-gray-500'
              >
                Audience
              </TableCell>

              <TableCell
                sx={{ width: 200, p: 1 }}
                className='text-center text-xs font-bold text-gray-500'
              >
                Name
              </TableCell>

              <TableCell
                sx={{ width: 50, p: 1, pr: 8 }}
                className='text-center text-xs font-bold text-gray-500'
              >
                Phone Number
              </TableCell>

              <TableCell
                sx={{ width: 50, p: 1, pr: 12 }}
                className='text-center text-xs font-bold text-gray-500'
              >
                Status
              </TableCell>

              <TableCell
                sx={{ width: 150, p: 1 }}
                className='text-center text-xs font-bold text-gray-500'
              >
                Updated at
              </TableCell>

              <TableCell
                sx={{ width: 100, p: 1 }}
                className='text-center text-xs font-bold text-gray-500'
              >
                Error Code
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {Array.isArray(filteredReport) && filteredReport.length > 0 ? (
              filteredReport

                .sort(
                  (a, b) =>
                    dayjs(b.msg_sent_provider_status_updated_at).valueOf() -
                    dayjs(a.msg_sent_provider_status_updated_at).valueOf(),
                )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow
                    key={row?.the_id}
                    hover
                    tabIndex={-1}
                    sx={{
                      '&:hover': {
                        backgroundColor: '#F9FAFB',
                      },
                      transition: 'background-color 0.2s ease',
                    }}
                  >
                    <TableCell
                      sx={{
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                        maxWidth: 150,
                        py: 1.1,
                        pl: 3,
                      }}
                      className='text-sm font-bold text-gray-500'
                    >
                      {row?.data_scope || '-'}
                    </TableCell>

                    <TableCell
                      sx={{ py: 1.5 }}
                      className='text-sm font-bold text-gray-500'
                    >
                      {row?.audience_contact_segment || '-'}
                    </TableCell>

                    <TableCell
                      sx={{ py: 1.5 }}
                      className='text-sm font-bold text-gray-500'
                    >
                      {row?.audience_contact_name || '-'}
                    </TableCell>

                    <TableCell
                      sx={{ py: 1.5 }}
                      className='text-sm font-bold text-gray-500'
                    >
                      {row?.audience_contact_value || '-'}
                    </TableCell>

                    <TableCell sx={{ py: 1.5 }}>
                      <Box
                        sx={{
                          backgroundColor:
                            row?.msg_sent_provider_status === 'read'
                              ? '#DCFCE7'
                              : row?.msg_sent_provider_status === 'delivered' ||
                                row?.msg_sent_provider_status === 'sent' ||
                                row?.msg_sent_provider_status === 'accepted' ||
                                row?.msg_sent_provider_status === 'queued'
                              ? '#E0F2FE'
                              : '#FEF3C7',
                          color:
                            row?.msg_sent_provider_status === 'read'
                              ? '#15803D'
                              : row?.msg_sent_provider_status === 'delivered' ||
                                row?.msg_sent_provider_status === 'sent' ||
                                row?.msg_sent_provider_status === 'accepted' ||
                                row?.msg_sent_provider_status === 'queued'
                              ? '#0369A1'
                              : '#92400E',
                          borderRadius: '12px',
                          px: 1.5,
                          py: 0.5,
                          display: 'inline-block',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          textTransform: 'capitalize',
                          width: '95px',
                          textAlign: 'center',
                        }}
                      >
                        {row?.msg_sent_provider_status}
                      </Box>
                    </TableCell>

                    <TableCell
                      sx={{ py: 1.5 }}
                      className='text-sm font-bold text-gray-500'
                    >
                      {row?.msg_sent_provider_status_updated_at
                        ? dayjs(row.msg_sent_provider_status_updated_at)
                            .utc()
                            .format('DD MMM YYYY, h:mm A')
                        : '-'}
                    </TableCell>

                    <TableCell
                      sx={{ py: 1.5 }}
                      className='text-sm font-bold text-gray-500'
                    >
                      {row?.msg_sent_provider_error_code || '-'}
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align='center'>
                  <Typography className='font-poppins py-6 italic text-gray-400'>
                    No data listed
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Box
          className='flex justify-end py-3'
          sx={{ width: '100%', fontFamily: 'Poppins' }}
        >
          <TablePagination
            component='div'
            count={pagination?.totalItems || 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
          />
        </Box>
      </TableContainer>
    </Box>
  );
}

function Tabs({
  campaign,
  setCampaign,
  totalWords,
  showModal,
  handleUpdateStatus,
  handleExecute,
}) {
  const categories = [
    {
      idx: 0,
      title: 'Content',
      component: (
        <div>
          <PreviewMessage
            campaign={campaign}
            setCampaign={setCampaign}
            totalWords={totalWords}
            showModal={showModal}
            handleUpdateStatus={handleUpdateStatus}
            handleExecute={handleExecute}
          />
        </div>
      ),
    },
    {
      idx: 1,
      title: 'Report',
      component: (
        <div>
          <ReportCard title='Total Users' value='1,024' />
        </div>
      ),
    },
  ];
  return (
    <div className='p-4 pt-8'>
      <LabTabs menus={categories} />
    </div>
  );
}
